/**
 * useTheme — custom React hook to access ThemeContext state and controls.
 *
 * @throws {Error} if invoked outside of <ThemeProvider>
 */

import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from '../context/ThemeContext';

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
